"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Article pagination](https://docs.vanillaframework.io/patterns/article-pagination/).
 *
 * The article pagination component should be used to navigate from one article to the next, or previous, in chronological order.
 */
const ArticlePagination = _ref => {
  let {
    className,
    nextURL,
    nextLabel,
    previousURL,
    previousLabel,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("footer", _extends({
    className: (0, _classnames.default)(className, "p-article-pagination")
  }, props), previousURL && previousLabel && /*#__PURE__*/_react.default.createElement("a", {
    className: "p-article-pagination__link--previous",
    href: previousURL
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "p-article-pagination__label"
  }, "Previous"), /*#__PURE__*/_react.default.createElement("span", {
    className: "p-article-pagination__title"
  }, previousLabel)), nextURL && nextLabel && /*#__PURE__*/_react.default.createElement("a", {
    className: "p-article-pagination__link--next",
    href: nextURL
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "p-article-pagination__label"
  }, "Next"), /*#__PURE__*/_react.default.createElement("span", {
    className: "p-article-pagination__title"
  }, nextLabel)));
};
var _default = exports.default = ArticlePagination;